<template>
    <div class="human-map">
        <div class="no-answer" style="margin-left: 14px;" v-if="!response">
            <span>
                Not Answered
            </span>
        </div>
        <template v-if="response && Array.isArray(response)">
            <div class="wrapper_section">
                <div class="response_wrapper">
                    <div class="side-response" v-if="front_response.length > 0">
                        <p class="side">Front:</p>
                        <div class="response">
                            <ul class="part-list choice-wrapper">
                                <li v-for="(response) in front_response" :key="response.name">
                                    {{ response.name }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="side-response" v-if="side_response.length > 0">
                        <p class="side">Side:</p>
                        <div class="response">
                            <ul class="part-list choice-wrapper">
                                <li v-for="(response) in side_response" :key="response.name">
                                    {{ response.name }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="side-response" v-if="back_response.length > 0">
                        <p class="side">Back:</p>
                        <div class="response">
                            <ul class="part-list choice-wrapper">
                                <li v-for="(response) in back_response" :key="response.name">
                                    {{ response.name }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="side-response" v-if="face_response.length > 0">
                        <p class="side">Face:</p>
                        <div class="response">
                            <ul class="part-list choice-wrapper">
                                <li v-for="(response) in face_response" :key="response.name">
                                    {{ response.name }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="side-response" v-if="body_response.length > 0">
                        <p class="side">Body:</p>
                        <div class="response">
                            <ul class="part-list choice-wrapper">
                                <li v-for="(response) in body_response" :key="response.name">
                                    {{ response.name }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { OLD, GENERAL_LOCATION, RASH, SwollenLymphNodes, BreastProblems, Abdomen, ChestThoracic, Back, Hip, SHOULDER, ARM, HAND, HEAD, LEG, KNEE, ANKLE, FOOT, SWELLING } from '@/module/util/get-bodymap'

export default {
    name: 'human-map-partial',
    
    props: {
        // Content object for this question
		question: {
			type: Object,
			required: true
		},
		response: {
			type: Array,
		},
    },

    data() {
        return {
            front_response: [],
            back_response: [],
            side_response: [],
            face_response: [],
            body_response: []
        }
    },

    methods: {
        getBodyMapper(type) {
            if (type === 'old') return OLD
            if(type === "general_location") return GENERAL_LOCATION
            if(type === "breast_problems") return BreastProblems
            if(type === "rash") return RASH
            if(type === "swollen_lymph_nodes") return SwollenLymphNodes

            if(type === "abdominal") return Abdomen
            if(type === "chest_thoracic") return ChestThoracic
            if(type === "back") return Back
            if(type === "hip") return Hip
            if(type === "shoulder") return SHOULDER
            if(type === "arm") return ARM
            if(type === "hand") return HAND
            if(type === "head") return HEAD
            if(type === "leg") return LEG
            if(type === "knee") return KNEE
            if(type === "ankle") return ANKLE
            if(type === "swelling") return SWELLING
            if(type === "foot_toes") return FOOT
            
        }
    },

    mounted() {
        let type = this.question.hasOwnProperty('sub_type') ? this.question.sub_type : 'old'
        const mapper = this.getBodyMapper(type)
        if(Array.isArray(this.response)) {
            this.response.forEach(id => {
                if(mapper[id]) {
                    if(mapper[id].side === "Front") this.front_response.push(mapper[id])
                    else if(mapper[id].side === "Side") this.side_response.push(mapper[id])
                    else if(mapper[id].side === "Face") this.face_response.push(mapper[id])
                    else if(mapper[id].side === "Body") this.body_response.push(mapper[id])
                    else if(mapper[id].side === "Back") this.back_response.push(mapper[id])
                    // else this.back_response.push(mapper[id])
                }
                else
                    this.front_response.push({name: id})
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../style.scss";

.wrapper_section {
    display: flex;
    align-items: baseline;

    .date {
        font-weight: 400;
        font-size: 11px;
        color: #333333;
    }

    .side {
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        color: #666666;
    }

    .response {
        border: none;
        padding: 0;
        width: 100%;
    }
   

    .side-response {
        display: flex;
        align-items: baseline;
    }
}

.response_wrapper {
    width: 100%;
}
</style>
